<template>
    <div>
        <v-alert type="warning" dismissible v-for="(value, index) in warningsLabels" :key="'submit'+index">
            {{value}}: {{warningsValues[index]}}
        </v-alert>
        <v-btn
            color="success"
            :target="field.extra.link_target"
            @click="submitButton"
        >
            {{field.extra.link_name}}
        </v-btn>
        <div v-if="buttonContentHtml" v-html="buttonContentHtml"></div>

    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "Submit",
    props: ['field', 'label', 'stageId', 'prevUrl'],
    data(){
        return {
            warningsLabels: [],
            warningsValues: [],
            buttonContentHtml: null
        }
    },

    computed: {
        ...mapState({proceduresStore: state => state.procedures}),
    },

    watch: {
        '$store.state.procedures.submitButtonContent'(){
            this.submitButtonRequestSuccess()
        }
    },

    methods: {
        ...mapActions('procedures', ['getSubmitButtonRequest']),

        submitButton(){
            let request = {stage_id: this.stageId, field_id: this.field.id}

            this.getSubmitButtonRequest(request)
        },

        submitButtonRequestSuccess(){
            console.log("success values")
            let submitContent = this.proceduresStore.submitButtonContent
            if (submitContent.type === 'json'){
                if (typeof submitContent.data === 'object'){
                    this.warningsLabels = Object.keys(submitContent.data)
                    this.warningsValues = Object.values(submitContent.data)
                }else{
                    this.warningsLabels.push('mensaje')
                    this.warningsValues.push(submitContent.data)
                }
            }else{
                this.buttonContentHtml = submitContent.data
            }
        }

        //TODO: ver como hacer el url_redirect
    }
}
</script>